import { render, staticRenderFns } from "./my-org-freezer.vue?vue&type=template&id=c6fcc216&scoped=true&"
import script from "./my-org-freezer.vue?vue&type=script&lang=js&"
export * from "./my-org-freezer.vue?vue&type=script&lang=js&"
import style0 from "./my-org-freezer.vue?vue&type=style&index=0&id=c6fcc216&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6fcc216",
  null
  
)

export default component.exports